import React from 'react';

import { VIEW_TO_PATH } from '../routes';
import { useApp } from '../store/AppContext';

export default function JiraSyncAlert() {
  const { isManager, jiraHealthDismissedAt, jiraSyncHealth, navigate, setJiraHealthDismissedAt } =
    useApp();
  if (!(
    isManager &&
    jiraSyncHealth?.last_error_at &&
    jiraSyncHealth.last_error_at !== jiraHealthDismissedAt &&
    (!jiraSyncHealth.last_success_at ||
      jiraSyncHealth.last_error_at > jiraSyncHealth.last_success_at)
  ))
    return null;
  return (
    <div className="flex items-center gap-[10px] bg-[#FBEAEA] [border:1px_solid_#F0B8B8] rounded-[10px] py-[10px] px-[16px] mb-[16px] text-[13px] text-[#8A2F2A]">
      <i className="ti ti-alert-triangle text-[16px] text-danger shrink-0" aria-hidden="true" />
      <div className="[flex:1]">
        La synchro Jira temps réel a échoué le{' '}
        {new Date(jiraSyncHealth.last_error_at).toLocaleString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })}
        {jiraSyncHealth.last_error_project ? ` (projet ${jiraSyncHealth.last_error_project})` : ''}{' '}
        : {jiraSyncHealth.last_error_message}
      </div>
      <button
        className="btn btn-sm text-[11px] shrink-0"
        onClick={() => navigate(VIEW_TO_PATH.jira)}
      >
        Voir
      </button>
      <button
        className="btn btn-sm text-[11px] shrink-0"
        onClick={() => setJiraHealthDismissedAt(jiraSyncHealth.last_error_at)}
      >
        Masquer
      </button>
    </div>
  );
}
